import { graphql } from "@cappelendamm/crystallize-types/subscriptions/gql";
export const getUsageTracked = async ({ contractId }, { client }) => {
    const data = await client.subscriptions.request(graphql(`
      query GetUsage($id: ID!, $tenantId: ID!) {
        subscriptionContractEvents {
          getMany(
            subscriptionContractId: $id
            eventTypes: usageTracked
            last: 25
            tenantId: $tenantId
          ) {
            edges {
              node {
                createdAt
                __typename
                ... on SubscriptionContractUsageTrackedEvent {
                  data {
                    meteredVariableId
                    quantity
                    idempotencyKey
                    description
                  }
                }
              }
            }
          }
        }
      }
    `), { id: contractId, tenantId: client.tenantId });
    const trackedUsage = data.subscriptionContractEvents?.getMany?.edges?.reduce((acc, { node }) => {
        if (node.__typename === "SubscriptionContractUsageTrackedEvent") {
            return [...acc, { ...node.data, createdAt: node.createdAt }];
        }
        else {
            return acc;
        }
    }, []);
    return trackedUsage ?? [];
};
